// extracted by mini-css-extract-plugin
export default {"AdSlotMail__mail":"bgi_a bhi_wj bhi_a bhi_q bhi_k","AdSlotMail__mail--notLoaded":"bgi_b bhi_ey bhi_bj bhi_wy","show-ad-not-loaded":"bgi_c","AdSlotMail__cta":"bgi_e"};